module.exports = __webpack_public_path__ + "static/media/globalPeaceGap2019.c184cf37.png";